import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, Button } from '@mui/material';

// Enkel “kryptering” och dekryptering
//const encode = (str) => btoa(str); // Base64
const decode = (str) => atob(str);

const YourSecret = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const from = searchParams.get('from') || '???';
  const toParam = searchParams.get('to');
  const to = toParam ? decode(decodeURIComponent(toParam)) : '???';
  const toObject = JSON.parse(to);

  return (
    <Box
      sx={{
        mt: 4,
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <Paper sx={{ p: 6, maxWidth: 500, width: '100%', textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Hej <strong>{from}</strong>! Du ska ge en present till:
        </Typography>

        <Typography
          variant="h3"
          sx={{ fontFamily: 'monospace', wordBreak: 'break-all', mt: 2 }}
        >
          {toObject.to}
        </Typography>

        {/* Diskret knapp i hörnet */}
        <Button variant="text" size="small" onClick={() => navigate('/')}>
          Skapa din egen SecretSanta
        </Button>
      </Paper>
    </Box>
  );
};

export default YourSecret;
